import "./FormTextInput.css";

const FormTextInput = (props) => {
  const { inputLabel, onChange, inputValue, labelButtonText, onClickLabelButton, inputType='text' } = props;
  return (
    <div className="form-text-input-container">
      <div className='form-text-input-label-container'>
        <div className="form-text-input-label">{inputLabel}:</div>
        <div onClick={onClickLabelButton} className='forgot-password-button'>{labelButtonText}</div>
      </div>
      <input type={inputType} name={inputLabel} id={inputLabel} onChange={onChange} value={inputValue} />
    </div>
  );
};

export default FormTextInput;
